import PropTypes from 'prop-types';
import React from 'react';

import { Tag } from '$partials/ui';
import { StaticTitle } from '$partials/layout/side-titles.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ExploreTag = ({
    leftHeading  = null,
    leftTags     = null,
    namespace    = null,
    rightHeading = null,
    rightTags    = null,
    sideTitle    = null,
    title        = null
}) => {
    // render
    return (
        <section className='module-explore-tag'>
            <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                <div className='flex flex-wrap'>
                    {/* side title */}
                    <div className='absolute top-0 md-relative md-col-2'>
                        {sideTitle && (
                            <div className='px-gutter'>
                                <p className={`type-style-5 side-title${title ? '' : ' side-title--lesser-top'}`}>
                                    <StaticTitle title={sideTitle} />
                                </p>
                            </div>
                        )}
                    </div>

                    {/* content */}
                    <div className={`col-12${namespace?.includes('search-modal') ? ' sm-col-12 md-col-10' : ' sm-col-12 md-col-10'}`}>
                        <div className='ml9 sm-ml9 md-ml0'>
                            <div className='flex flex-wrap'>
                                {/* title */}
                                {title && (
                                    <>
                                        <div className='col-11 sm-col-8 md-col-7'>
                                            <div className='px-gutter'>
                                                <div
                                                    className='rich-text type-style-1 mb7 sm-mb7 md-mb10'
                                                    dangerouslySetInnerHTML={{ __html: title }} />
                                            </div>
                                        </div>

                                        <div className='hide md-show md-col-5' />
                                    </>
                                )}

                                {/* left column */}
                                <div className='col-12 sm-col-6 md-col-6 mb7 sm-mb0 md-mb0'>
                                    <div className='px-gutter'>
                                        {/* left heading */}
                                        {leftHeading && (
                                            <h3 className='type-style-3 mb5 pb2 border-bottom border-black'>
                                                {leftHeading}
                                            </h3>
                                        )}

                                        {/* left tags */}
                                        <ul className='list-reset flex flex-wrap'>
                                            {leftTags?.map((tag, idx) => {
                                                return (
                                                    <li
                                                        className='mb2 mr2'
                                                        key={idx}>
                                                        <Tag {...tag} />
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>

                                {/* right column */}
                                <div className='col-12 sm-col-6 md-col-6 mb7 sm-mb0 md-mb0'>
                                    <div className='px-gutter'>
                                        {/* right heading */}
                                        {rightHeading && (
                                            <h3 className='type-style-3 mb5 pb2 border-bottom border-black'>
                                                {rightHeading}
                                            </h3>
                                        )}

                                        {/* right tags */}
                                        <ul className='list-reset flex flex-wrap'>
                                            {rightTags?.map((tag, idx) => {
                                                return (
                                                    <li
                                                        className='mb2 mr2'
                                                        key={idx}>
                                                        <Tag {...tag} />
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    leftHeading : PropTypes.string,
    leftTags    : PropTypes.array,
    namespace   : PropTypes.string,
    rightHeading: PropTypes.string,
    rightTags   : PropTypes.array,
    sideTitle   : PropTypes.string,
    title       : PropTypes.string,
};

ExploreTag.propTypes = propTypes;

export { ExploreTag };

export default ExploreTag;
